'use client';

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

interface AppToasterProps extends Omit<ToasterProps, 'theme'> {
  /**
   * Dark mode is driven by the `dark` class on <html> via the in-app toggle,
   * not a next-themes ThemeProvider. The theme comes from the caller's Root
   * state (a render-time prop) rather than reading document.documentElement
   * during render, which is a side-effecting read that can't be tracked as a
   * React dependency.
   */
  darkMode: boolean;
}

const Toaster = ({ darkMode, ...props }: AppToasterProps) => {
  const theme: ToasterProps['theme'] = darkMode ? 'dark' : 'light';

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
